import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

export default function SystemAvatarMini({
    displayName,
    guid
}) {

    const [t] = useTranslation("global")

    return (
        <NavLink  className="btn btn-dark me-1 opacity-75">
            <img className="rounded-circle p-1 me-2 " width="48px" src={`/eh_pattern.png`}/>
            {displayName}
        </NavLink>
    )
}